const wymiaryexport = {
  state: {
    wysokosci: [
      ["20", 2070],
      ["22", 2070],
      ["21", 2080],
      ["23", 2091],
      ["30", 2087],
      ["32", 2087],
      ["31", 2100],
      ["41", 2100],
      ["60", 2072],
      ["80", 2076],
      ["81", 2076],
      ["82", 2094.5],
      ["83", 2094.5],
      ["85", 2076],
      ["86", 2076],
      ["87", 2094.5],
      ["88", 2094.5],
      ["520", 2090],
      ["521", 2084],
      ["522", 2100],
      ["661", 2100],
    ],
    szerokosci: [
      ["80", "90", 1020],
      ["81", "90", 1020],
      ["82", "90", 1057],
      ["83", "90", 1057],
      ["85", "90", 1020],
      ["86", "90", 1020],
      ["87", "90", 1057],
      ["88", "90", 1057],
      ["20", "75", 858],
      ["20", "80", 908],
      ["20", "85", 958],
      ["20", "90", 1008],
      ["22", "90", 1008],
      ["23", "90", 1037],
      ["20", "100", 1108],
      ["21", "75", 875],
      ["21", "80", 925],
      ["21", "85", 975],
      ["21", "90", 1025],
      ["21", "100", 1125],
      ["30", "75", 884],
      ["30", "80", 934],
      ["30", "85", 984],
      ["30", "90", 1034],
      ["32", "90", 1034],
      ["30", "100", 1134],
      ["31", "75", 911],
      ["31", "80", 961],
      ["31", "85", 1011],
      ["31", "90", 1061],
      ["31", "100", 1161],
      ["41", "75", 953],
      ["41", "80", 1003],
      ["41", "85", 1053],
      ["41", "90", 1083],
      ["60", "90", 1016],
      ["520", "90", 1042],
      ["521", "90", 1028],
      ["522", "90", 1051],
      ["661", "90", 1114],
    ],
  },
  getters: {
    szerokosc: (state, getters, rootState) => {
      return state.szerokosci.filter((el) => el[0] == rootState.product.seria).find((el) => el[1] == rootState.product.kodrozmiaru)[2];
    },
    wysokosc: (state, getters, rootState) => {
      return state.wysokosci.find((el) => el[0] == rootState.product.seria)[1];
    },
  },
};

export default wymiaryexport;
